import styled, { css } from 'styled-components';

const Arrow = styled.button<{ isDisabled?: boolean }>`
	opacity: 0;
	pointer-events: none;
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
	background-color: var(--generic-overlay);
	padding: 6px;
	transition: all 0.2s ease-in;
	cursor: pointer;
	border-radius: 50%;

	svg {
		fill: var(--main-action-icons);
	}
`;

const LeftArrow = styled(Arrow)`
	left: 12px;
	svg {
		transform: translateX(-1px);
	}
`;

const RightArrow = styled(Arrow)`
	right: 12px;
	svg {
		transform: translateX(1px);
	}
`;

const SliderWrapper = styled.div<{ isScrollingDisabled: boolean; gap: number; paddingX: number; $isDragging: boolean }>`
	display: flex;
	gap: ${({ gap }) => `${gap}px`};
	padding: 0 ${({ paddingX }) => `${paddingX}px`};

	overflow-x: scroll;
	cursor: ${({ isScrollingDisabled }) => (isScrollingDisabled ? 'default' : 'grab')};

	&::-webkit-scrollbar {
		display: none;
	}

	&:active {
		cursor: ${({ isScrollingDisabled }) => (isScrollingDisabled ? 'default' : 'grabbing')};
	}

	${({ $isDragging }) =>
		$isDragging &&
		css`
			& > .carousel-item {
				pointer-events: none;
			}
		`};
`;

export { SliderWrapper, LeftArrow, RightArrow };
